export var SubmissionPartialsType;
(function (SubmissionPartialsType) {
    SubmissionPartialsType["LAST_ACTIVITY"] = "last_activity";
    SubmissionPartialsType["QUESTIONNAIRE_LAUNCH"] = "questionnaire_launch";
})(SubmissionPartialsType || (SubmissionPartialsType = {}));
